import jwtDecode from 'jwt-decode'

export default (state={ }, action) =>  {
  switch(action.type) {
    case 'LOGIN_FULFILLED':
      var decoded = jwtDecode(action.payload.data.token);
      state = {
        ...decoded,
      };
      break;
    case 'LOGIN_REJECTED':
      state = {
        error: action.payload.response.data,
      };
      break;
    case 'REQUIRE_LOGIN':
      state = {
        error: action.payload.error
      }
      break;
    default: // Do nothing
  }
  return state;
};
